import { z } from 'zod';

export const CandidateStatSchema = z.object({
  count: z.number(),
  id: z.string(),
});

export type CandidateStat = z.infer<typeof CandidateStatSchema>;
